<template>
    <v-content>
      <v-container fluid>
        <v-alert v-if="error" :value="true" type="error">
          {{ error }}
        </v-alert>
        <GenericSingle
          :title="`Organisation`"
          :modelTitleField="`companyname`"
          :childTitle="`Project.Groups`"
          :previousPagePath="`/organisations`"
          :url="`/schemas/organisations`"
          :apiResponseField="`organisation`"
          :reconcileURL="`/device/details?organisation=`"
          :reconcileQueryField="`companyname`"
          :infoTable="[
              {key: 'Name', value: 'companyname'},
              {key: 'Description', value: 'description'},
            ]">
          <ProjectGroupListTable :parentID="parseInt(this.$route.params.id)" v-on:error="errorHandler" />
        </GenericSingle>
      </v-container>

    </v-content>
</template>

<script>
import GenericSingle from '@/components/Common/GenericSingle'
import ProjectGroupListTable from '@/components/Models/ProjectGroup/ListTable'

export default {
  name: 'OrganisationSingle',
  components: { ProjectGroupListTable, GenericSingle },
  data () {
    return {
      error: false
    }
  },
  methods: {
    errorHandler (error) {
      this.error = error
    }
  }
}
</script>

<style>
h1 .titleText {
  vertical-align: middle;
}
</style>
